import React from 'react'

const ImagePreview = ({ setPreviewShown = ()=>{}, previewImage}) => {
  return (
              <div
                  onClick={() => setPreviewShown(false)}
                  style={{
                      position: 'fixed',
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0,
                      zIndex: 9999,
                      backgroundColor: 'rgba(0, 0, 0, 0.8)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor:'zoom-out'
                  }}
              >
                  <img
                      src={previewImage}
                      alt={`Slide`}
                      style={{
                          // width: '60%',
                          height: '80vh',
                          aspectRatio: 1
                      }}
                  />
              </div>
  );
}

export default ImagePreview